import { Page } from "@/libs/model/common/index";
/**查询分页列表 - 所有登录用户 */
export class UserListVO extends Page {
  constructor() {
    super();
    this.name = "";
    this.orgType = "";
  }
}
export class UserResetPasswordVO {
  constructor() {
    this.password = "";
    this.userAuthId = "";
  }
}
